import { Button, Space, Divider } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  WhatsAppOutlined,
  InstagramOutlined,
  FacebookFilled,
  XOutlined,
} from "@ant-design/icons";
import { useState } from "react";
import PrimaryButton from "../../biblio/Buttons/PrimaryButton";
import Inputs from "../../biblio/Inputs/Inputs";
import share from "../../assets/icons/share-icon.svg";
import { shareLinks } from "./shareLinks";
import ModalComponent from "../../biblio/Modal/ModalComponent";

interface ShareCasesProps extends React.HTMLAttributes<HTMLDivElement> {
  url?: string;
  /** Name of the shared item, used in the share message. */
  title?: string;
  setIsPalmModalOpen: (value: boolean) => void;
  setIsShareModalVisible: (value: boolean) => void;
  isShareModalOpen: boolean;
}

const SharePalm = ({
  url,
  title,
  setIsPalmModalOpen,
  setIsShareModalVisible,
  isShareModalOpen,
}: ShareCasesProps) => {
  const [copied, setCopied] = useState<boolean>(false);
  const links = shareLinks(url, title);
  const handleCopy = () => {
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
      closeModal();
    }, 1000);
  };
  const closeModal = () => {
    setIsShareModalVisible(false);
    setIsPalmModalOpen(true);
  };
  return (
    <ModalComponent
      title=""
      open={isShareModalOpen}
      onClose={() => closeModal()}
      closeOnOutsideClick={true}
      width={400}
      modalStyle={{ top: -200 }}
      centered={true}
      showCloseIcon={true}
    >
      <div className="takaful--share-cases-container" style={{marginTop:"0.5rem"}}>
        <div className="takaful--share-cases-title-grand">
          <img width={32} src={share} alt="takaful" />
          <span>مشاركة وقف النخيل</span>
        </div>
        <Divider />
        <div className="takaful--share-cases-title-container">
          <h5>رابط وقف النخيل</h5>
          <Inputs readOnly value={url} className="takaful--input-share-link" />
          <div className="takaful--share-button-container">
            <CopyToClipboard text={url || ""} onCopy={handleCopy}>
              <PrimaryButton
                title="نسخ الرابط"
                className="takaful--share-button-copy"
              />
            </CopyToClipboard>
            {copied ? <p className="takaful--copied">تم نسخ الرابط</p> : null}
          </div>
        </div>

        <div className="takaful--share-cases-text-container">
          <h5>نشر عبر حسابك في التواصل الاجتماعي</h5>
          <Space className="takaful--share-cases-icons">
            <Button
              shape="circle"
              icon={
                <FacebookFilled
                  style={{ color: "#1877F2", fontSize: "20px" }}
                />
              }
              href={links.facebook}
              target="_blank"
              size="large"
              onClick={() => closeModal()}
            />
            <Button
              shape="circle"
              icon={<WhatsAppOutlined style={{ color: "#25D366" }} />}
              href={links.whatsapp}
              target="_blank"
              size="large"
              onClick={() => closeModal()}
            />
            <Button
              shape="circle"
              icon={<XOutlined style={{ color: "#000000" }} />}
              href={links.x}
              target="_blank"
              size="large"
              onClick={() => closeModal()}
            />
            <Button
              shape="circle"
              icon={<InstagramOutlined style={{ color: "#E1306C" }} />}
              href={links.instagram}
              target="_blank"
              size="large"
              onClick={() => closeModal()}
            />
          </Space>
        </div>
      </div>
    </ModalComponent>
  );
};

export default SharePalm;
